import React from "react";
import { Route, Switch } from "react-router-dom";

import { NUMBER_PORTING_REQUEST } from "constants/routes";
import { Admins } from "constants/userRoles";

import NumberPortingRequestIndex from "views/NumberPortingRequest/NumberPortingRequestIndex";
import ImportCreate from "views/NumberPortingRequest/Import/ImportCreate";
import ImportEdit from "views/NumberPortingRequest/Import/ImportEdit";
import ImportDetail from "views/NumberPortingRequest/Import/ImportDetail";
import ExportDetail from "views/NumberPortingRequest/Export/ExportDetail";

const NumberPortingRequestRoutes = () => (
  <Switch>
    <Route
      exact
      path={NUMBER_PORTING_REQUEST.IMPORT_CREATE}
      component={Admins(ImportCreate)}
    />
    <Route
      exact
      path={NUMBER_PORTING_REQUEST.IMPORT_EDIT}
      component={Admins(ImportEdit)}
    />
    <Route
      exact
      path={NUMBER_PORTING_REQUEST.IMPORT_DETAIL}
      component={Admins(ImportDetail)}
    />
    <Route
      exact
      path={NUMBER_PORTING_REQUEST.EXPORT_DETAIL}
      component={Admins(ExportDetail)}
    />
    <Route
      path={NUMBER_PORTING_REQUEST.INDEX}
      component={Admins(NumberPortingRequestIndex)}
    />
  </Switch>
);

export default NumberPortingRequestRoutes;
